import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-site',
  templateUrl: './admin-site.component.html',
  styles: []
})
export class AdminSiteComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  onActivate(event) {
    window.scroll(0, 0);
  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/admin-site/admin-site.component.ts